import { User } from "../models";
import { find } from "lodash";

export function isUserTenantAdmin(user: User, tenantId: string) {
  if (!user) {
    return false;
  }
  const scope = find(user.scopes, {
    tenant: tenantId,
    role: "ADMIN",
  });
  return !!scope;
}
